'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
const theme_Typography = require('../../../theme/Typography.cjs.js');
require('react');
const styleMixins_reset = require('../../../style-mixins/reset.cjs.js');

const styles = {
  root: (height, width) => {
    const widthMap = {
      full: "100%",
      large: "75%",
      medium: "50%",
      small: "25%"
    };
    return react.css(Object.assign(Object.assign(Object.assign({}, styleMixins_reset.boxSizing), theme_Typography.Typography.SmallPrint4), { alignItems: "center", textTransform: "uppercase", color: theme_Colors.Colors.TextWeakest, display: "flex", flex: 1, justifyContent: "space-between", letterSpacing: 1, padding: 0, position: "relative", textAlign: "center", width: widthMap[width] || "100%", "&::before, &::after": {
      borderBottom: `${height}px solid ${theme_Colors.Colors.GrayWarm4}`,
      content: '""',
      flex: 1
    } }));
  },
  content: react.css({
    margin: "0 var(--zds-space-20)"
  })
};
const Divider = ({ height, width, children, "aria-hidden": ariaHidden = void 0 }) => {
  return react.jsx("div", { role: "separator", css: styles.root(height, width || "full"), "aria-hidden": ariaHidden }, children && react.jsx("span", { css: styles.content }, children));
};

exports.Divider = Divider;
//# sourceMappingURL=Divider.cjs.js.map
